import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {ScheduleDependencies} from '../dependencies';
import {keys} from './keys';

export type GetScheduleWeekQueryDependencies = Pick<ScheduleDependencies, 'controllers'>;

export const getScheduleWeekQuery = ({controllers}: GetScheduleWeekQueryDependencies) =>
  queryOptions({
    queryKey: keys.week(),
    queryFn: () => controllers.scheduleController.getWeek().then(unwrap),
  });
